import { endpoint } from 'services/Api';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'exceptions';

/**
 * Exception Endpoints:
 *     - Exception
 */
export default {
    /**
     * Send the exception in the for of a slack notification
     *
     * @param  {Object} data
     *
     * @return {Promise}
     */
    errors(data) {
        return endpoint(RESOURCE, 'slack', {
            type: 'Error',
            error_msg: data.err.message,
            error_stack: data.err.stack
        });
    },

    /**
     * Send the exception in the for of a slack notification
     *
     * @param  {Object} data
     *
     * @return {Promise}
     */
    warnings(data) {
        return endpoint(RESOURCE, 'slack', {
            type: 'Warning',
            error_msg: data.msg,
            error_stack: data.trace
        });
    },
};


// WEBPACK FOOTER //
// ./src/services/api/exceptions.js